import styled, { css } from 'styled-components';

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 6px;

  ${({ theme }) => css`
    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
    }
  `}
`;

export const ProductName = styled.span`
  ${({ theme }) => css`
    font-size: 24px;
    font-weight: ${theme.v2.font.weights.bold};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: 20px;
    }
  `}
`;

export const Status = styled.div``;

export const PlanInfo = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const Domain = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    color: ${theme.v2.colors.neutral.lowDark};
  `}
`;
